var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-wrapper",staticStyle:{"height":"100%"}},[_c('v-md-editor',{attrs:{"height":"100%","disabled-menus":[]},on:{"save":_vm.onSave,"upload-image":_vm.handleUploadImage},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }